// src/pages/Home.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <header className="hero">
        <h1>Ivyron Smart Home Voice Control</h1>
        <p>Control your smart home devices with natural language commands</p>
        <div className="cta-buttons">
          <Link to="/login" className="button primary">Get Started</Link>
          <Link to="/dashboard?tab=command#input-section" className="button secondary">Demo</Link>
        </div>
      </header>
      
      <section className="features">
        <h2>Features</h2>
        <div className="feature-grid">
          <div className="feature-card">
            <h3>Voice Control</h3>
            <p>Control your devices using natural language commands</p>
          </div>
          <div className="feature-card">
            <h3>Cross-Platform</h3>
            <p>Works on all browsers and mobile devices</p>
          </div>
          <div className="feature-card">
            <h3>Secure</h3>
            <p>Built with privacy and security in mind</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;